import Vue from 'vue'
import Router from 'vue-router'

import index from '@/views/home'
Vue.use(Router)

const routes = [
    {
        path: '/',
        redirect: '/home',
    },
    {
        path: '/index',
        component: index,
    },
    {
        path: '/forum',
        name: 'forum',
        component: () => import('@/views/sharing'),
        meta: {
            title: 'post-share',
            keepAlive: false,
        },
        children: [
            {
                path: 'post-share/:title',
                name: 'sharing',
                component: () => import('@/views/sharing'),
                meta: {
                    keepAlive: false,
                },
            },
        ],
    },
    {
        path: '/lottery',
        name: 'lottery',
        meta: {
            title: 'Trucker Path',
        },
        component: () => import('@/views/lottery'),
    },
    {
        path: '/gold-member',
        name: 'gold-member',
        meta: {
            title: 'Premium Purchase-Trucker Path',
        },
        component: () => import('@/views/goldMember'),
    },
    {
        path: '/dimond-member',
        name: 'dimond-member',
        component: () => import('@/views/dimondMember/index.vue'),
        children: [
            {
                path: 'order',
                redirect: '/order',
                // name: 'order',
                // component: () => import('@/views/dimondMember/buy.vue'),
            },
        ],
    },
    {
        path: '/order',
        name: 'order',
        component: () => import('@/views/dimondMember/buy.vue'),
    },
    {
        path: '/success',
        name: 'success',
        meta: {
            title: 'Premium Purchase-Trucker Path',
        },
        component: () => import('@/views/goldMember/success-payment'),
    },
    {
        path: '/share-test',
        name: 'share-test',
        meta: {
            title: 'Trucker test',
        },
        component: () => import('@/views/shareTest'),
    },
    {
        path: '/vipland',
        name: 'vipland',
        meta: {
            title: 'Premium Purchase-Trucker Path',
        },
        component: () => import('@/views/viplanding'),
    },
    {
        // path: process.env.NODE_ENV === 'production' ?
        //   "/trucker-report-2019/year-review": '/year-review',
        path: '/year-review',
        name: 'year-review',
        meta: {
            title: '2019 Year in Review',
        },
        component: () => import('@/views/yearReview'),
    },
    {
        path: '/rearview',
        name: 'personal rearview',
        component: () => import('@/views/rearview/index.vue'),
    },
    {
        path: '/test/deeplink',
        name: 'test-deeplink',
        meta: {
            title: 'Test Deeplink',
        },
        component: () => import('@/views/test/deeplink'),
    },
    {
        path: '/discover',
        name: 'discover',
        component: () => import('@/views/discover'),
        meta: {
            title: 'Discover',
            keepAlive: false,
        },
    },
    {
        path: '/job-board',
        name: 'job-board',
        component: () => import('@/views/jobBoard/index.vue'),
        meta: {
            title: 'Job Board',
            keepAlive: false,
        },
    },
]

export default new Router({
    mode: 'history',
    routes,
})
